import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_176: DocMigration = {
  maxSchemaVersion: "0.0.176",
  description: "change ceilingHeight variable to be called topOfWall",

  apply(json: any) {
    if (json.levels) {
      const levels = Array.isArray(json.levels) ? json.levels : Object.values(json.levels);
      for (const level of levels) {
        if (level.ceilingHeight !== undefined) {
          level.topOfWall = level.ceilingHeight;
          delete level.ceilingHeight;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_176;
